<template>
  <div class="mainContainer">
    <ChatContact @selectedChat="selectedChat" :id="this.$route.query.id" :queryLineId="queryLineId" :disabled="disabled"/>
    <ChatDisplay :show="show" :infoProps="info" :filter="filter" @loadingHandler="loadingHandler"/>
  </div>
</template>

<script>
import ChatContact from '@/components/chat/ChatContact'
import ChatDisplay from '@/components/chat/ChatDisplay'

export default {
  name: 'ChatBoard',
  components: {
    ChatContact,
    ChatDisplay,
  },
  data () {
    return {
      info: {},
      show: false,
      filter: {},
      firstLineId: '',
      queryLineId: '',
      disabled: false,
    }
  },
  mounted () {
    // get userId form query string when first load this page
    this.queryLineId = this.$route.query.id
    if (this.queryLineId !== undefined) this.show = true
    else this.queryLineId = ''
  },
  methods: {
    selectedChat (obj) {
      this.filter = obj.filter
      if (obj.info.lineId !== '') {
        this.info = obj.info
        this.$router.push({ name: 'ChatBoard', query: { id: obj.info.lineId } }, () => {})
        this.show = true
      } else {
        this.show = false
      }
    },
    loadingHandler (value) {
      this.disabled = value
    },
  },
}
</script>

<style lang="scss" scoped>
.mainContainer {
  padding-top: 60px;
  display: flex;
  flex-direction: row;
  height: 100vh;
}

</style>
